<div class="chart-card">
  <div class="chart-header">
    <h3>{{title|traduccion}}</h3>
    <span *ngIf="subtitle">{{subtitle|traduccion}}</span>
  </div>

  <div class="chart-container" [class.chart-container--legend]="isSpecialLegend" [class.chart-container--compact-legend]="isCompactLegend">
    <div
      class="chart-left"
      [class.chart-left--legend]="isSpecialLegend"
      [class.chart-left--doughnut]="type === 'doughnut'"
      [class.chart-left--compact-doughnut]="isCompactLegend">
      <canvas #chartCanvas [attr.height]="canvasHeight"></canvas>
    </div>

    <div *ngIf="isSpecialLegend" class="chart-right" [class.chart-right--compact]="isCompactLegend">

      <div *ngFor="let item of legends | keyvalue; let i = index" class="legend-item">
        <span class="dot" [style.background-color]="backgroundColor[i % backgroundColor.length]"></span>
        <span class="label">{{ item.key | traduccion }}</span>
        <span class="value">{{ item.value }}</span>
      </div>

      <div class="duration">

      </div>

    </div>


  </div>


  <mat-divider></mat-divider>

  <div class="chart-footer" *ngIf="footer">
    <mat-icon>schedule</mat-icon>
    {{footer}}
  </div>

</div>
